module.exports = __webpack_public_path__ + "static/iwoniczanka-347b4d92248f6e360e9c7699ca68d427.png";